import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import ClassicNotificationEmailActionMetadata from 'automation-ui-action-features/actions/classic-notification-email/records/ClassicNotificationEmailActionMetadata';
import ClassicNotificationEmailActionSummary from 'automation-ui-action-features/actions/classic-notification-email/ClassicNotificationEmailActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function ClassicNotificationEmailActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(ClassicNotificationEmailActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
ClassicNotificationEmailActionCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicNotificationEmailActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ClassicNotificationEmailActionCard;